module.exports = __webpack_public_path__ + "static/goblins_bugbears-8b20b7bcc066aedd10ee466876278f5d.jpg";